<div id="registration" class="registration-container ya-typography">
  <ya-subheader [hasContent]="true">
    <mat-tab-group mat-stretch-tabs id="headerTabs" [(selectedIndex)]="currentHeaderIndex" animationDuration="20ms"
      (selectedTabChange)="headerTabIndexChange($event)"
      class="ya-tab-group ya-tab-group--bodyless ya-tab-group--notStretch">
      <mat-tab>
        <ng-template mat-tab-label>
          <span langkey="phRegistration_TabName_Register"></span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span langkey="phRegistration_TabName_Login"></span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </ya-subheader>
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop" (swipeleft)="swipeLeftHandler()"
    (swiperight)="swipeRightHandler()">
    <mat-tab-group mat-stretch-tabs #registrationTabGroup [(selectedIndex)]="currentHeaderIndex"
      (selectedIndexChange)="selectedTabIndexChange($event)" animationDuration="20ms"
      (selectedTabChange)="selectedTabChange($event)" class="ya-headerless-tab-group">
      <mat-tab>
        <ng-template matTabContent>
          <div class="ya-tab-content-wrapper">
            <div class="registeration-tab-title">
              <span langkey="phRegistr_Tab_Title"></span>
            </div>
            <form #registerForm="ngForm" class="form-wrapper">
              <ya-customInput #registerUserNameCustomInput name="registerUserName" inputType="email"
                [(ngModel)]="registerViewModel.userName" (enterKeyUp)="handleRegisterEnterKeyup($event)"
                inputPlaceholder="phRegistration_Email_PlaceHolder" appEmailValidator required>
                <ng-container *ngIf="registerForm.form.controls['registerUserName']">
                  <ya-errorvalidation
                    [controlValidation]="registerForm.form.controls['registerUserName'].invalid && registerForm.form.controls['registerUserName'].touched"
                    errorMessage="phRegisteration_Validate_Email"></ya-errorvalidation>
                </ng-container>
              </ya-customInput>
              <ya-customInput name="registerPassword" inputType="password" [(ngModel)]="registerViewModel.password"
                (enterKeyUp)="handleRegisterEnterKeyup($event)" inputPlaceholder="phRegistration_Password_PlaceHolder"
                appPasswordValidator required>
                <ng-container *ngIf="registerForm.form.controls['registerPassword']">
                  <ya-errorvalidation
                    [controlValidation]="registerForm.form.controls['registerPassword'].invalid && registerForm.form.controls['registerPassword'].touched"
                    errorMessage="phRegisteration_Validate_Password"></ya-errorvalidation>
                </ng-container>
              </ya-customInput>

              <hr class="register-privacy-divider">
              <div class="privacy-wrapper">
                <div class="privacy-check">
                  <mat-checkbox a11y_Checkbox class="custom-ripple" name="checkPrivacy" [(ngModel)]="checkPrivacy"
                    #chkTerm="ngModel" (change)="privacyCheckeChange($event)" required>
                  </mat-checkbox>
                </div>
                <div class="privacy-content ya-caption" #privacyContent
                  [innerHtml]="settingsViewModel.register_term_text">
                </div>
                <ng-container *ngIf="registerForm.form.controls['checkPrivacy']">
                  <ya-errorvalidation
                    [controlValidation]="!registerForm.form.controls['checkPrivacy'].valid && registerForm.form.controls['checkPrivacy'].touched"
                    errorMessage="phRegistration_CheckPrivacy_Error"></ya-errorvalidation>
                </ng-container>
              </div>
              <ya-newsletter-checkbox #newsletterCheckbox [checkRegistrationStatus]="false"></ya-newsletter-checkbox>
              <div class="ya-webshop-button-container">
                <ng-container *ngIf="registerForm.valid; then activeButton else deactiveButton"></ng-container>
                <ng-template #activeButton>
                  <button a11y_Button mat-flat-button (click)="submitRegisterData()">
                    <span langkey="phRegistration_RegisterTab_Registerbutton"></span>
                  </button>
                </ng-template>
                <ng-template #deactiveButton>
                  <span (click)="showErrorValidation(registerForm)">
                    <button a11y_Button mat-flat-button disabled>
                      <span langkey="phRegistration_RegisterTab_Registerbutton"></span>
                    </button>
                  </span>
                </ng-template>
              </div>
              <div *ngIf="registerFailed" class="register-failed ya-caption">
                <span>{{registerFailedMessage}}</span>
              </div>
            </form>


            <div class="ya-social-login-separator" *ngIf="thirdpartyLoginEnabled">
              <span langkey="phRegistration_ThirdPartyRegistration_Seperator"></span>
            </div>
            <div class="social-login-buttons" *ngIf="thirdpartyLoginEnabled">
              <!-- Container für Google Prompt -->
              <div id="google-prompt-container" style="position: relative;"></div>

              <button mat-stroked-button (click)="onGoogleRegister()" #googleButton
                class="thirdparty-button google-button" *ngIf="thirdpartyGoogleEnabled">
                <img src="assets/core/img/google-icon.svg" alt="Google Logo" />
                <span langkey="phRegistration_GoogleRegistration_Button"></span>
              </button>

              <button mat-stroked-button (click)="onFacebookRegister()" #facebookButton
                class="thirdparty-button facebook-button" *ngIf="thirdpartyFacebookEnabled">
                <img src="assets/core/img/facebook-icon.svg" alt="Facebook Logo" />
                <span langkey="phRegistration_FacebookRegistration_Button"></span>
              </button>
            </div>

          </div>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template matTabContent>
          <div class="ya-tab-content-wrapper">
            <div class="registeration-tab-title" [innerHtml]="loginTitleContent"></div>
            <div *ngIf="hasForgetPassword" class="forgetpassword-message">
              <span langkey="phRegisteration_ForgetPassword_Message"></span>
            </div>
            <form #loginForm="ngForm" class="form-wrapper">
              <ya-customInput #loginUserNameCustomInput name="loginUserName" inputType="email"
                [(ngModel)]="loginViewModel.userName" (enterKeyUp)="handleLoginEnterKeyup($event)"
                inputPlaceholder="phRegistration_Email_PlaceHolder" appEmailValidator required>
                <ng-container *ngIf="loginForm.form.controls['loginUserName']">
                  <ya-errorvalidation
                    [controlValidation]="loginForm.form.controls['loginUserName'].invalid && loginForm.form.controls['loginUserName'].touched"
                    errorMessage="phRegisteration_Validate_Email"></ya-errorvalidation>
                </ng-container>
              </ya-customInput>
              <ya-customInput name="loginPassword" inputType="password" [(ngModel)]="loginViewModel.password"
                (enterKeyUp)="handleLoginEnterKeyup($event)" inputPlaceholder="phRegistration_Password_PlaceHolder"
                required>
                <ng-container *ngIf="loginForm.form.controls['loginPassword']">
                  <ya-errorvalidation
                    [controlValidation]="loginForm.form.controls['loginPassword'].invalid && loginForm.form.controls['loginPassword'].touched"
                    errorMessage="phRegisteration_Validate_Email"></ya-errorvalidation>
                </ng-container>
              </ya-customInput>
              <div class="ya-failed-validation-message ya-caption">
                <ya-errorvalidation [controlValidation]="loginFailed" errorMessage="phLogin_Failed_message">
                </ya-errorvalidation>
              </div>
              <hr class="register-privacy-divider">
              <ng-container *ngIf="!hasForgetPassword">
                <div class="forget-password">
                  <a mat-button [ngClass]="'mat-button ya-caption'" (click)="navigateToForgetPassword()">
                    <span langkey="phRegistration_LoginTab_ForgetPassword"></span>
                  </a>
                </div>
              </ng-container>
              <div class="ya-button-group-wrapper">
                <div class="ya-button-group-container">
                  <div class="ya-webshop-button-container">
                    <ng-container *ngIf="loginForm.valid; then activeButton else deactiveButton"></ng-container>
                    <ng-template #activeButton>
                      <button a11y_Button mat-flat-button (click)="submitLoginData()">
                        <span langkey="phRegistration_LoginTab_LoginButton"></span>
                      </button>
                    </ng-template>
                    <ng-template #deactiveButton>
                      <span (click)="showErrorValidation(loginForm)">
                        <button a11y_Button mat-flat-button disabled>
                          <span langkey="phRegistration_LoginTab_LoginButton"></span>
                        </button>
                      </span>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="hasForgetPassword">
                    <div class="ya-button-container">
                      <button a11y_Button mat-flat-button (click)="navigateToForgetPassword()">
                        <span langkey="phRegistration_ForgetPassword_RequestAgain"></span>
                      </button>
                    </div>
                  </ng-container>
                </div>
              </div>
            </form>

            <div class="ya-social-login-separator" *ngIf="thirdpartyLoginEnabled">
              <span langkey="phRegistration_ThirdPartyLogin_Seperator"></span>
            </div>
            <div class="social-login-buttons" *ngIf="thirdpartyLoginEnabled">
              <button mat-stroked-button (click)="onGoogleRegister()" class="thirdparty-button google-button"
                *ngIf="thirdpartyGoogleEnabled">
                <img src="assets/core/img/google-icon.svg" alt="Google Logo" />
                <span langkey="phRegistration_GoogleRegistration_Button"></span>
              </button>

              <button mat-stroked-button (click)="onFacebookRegister()" class="thirdparty-button facebook-button"
                *ngIf="thirdpartyFacebookEnabled">
                <img src="assets/core/img/facebook-icon.svg" alt="Facebook Logo" />
                <span langkey="phRegistration_FacebookRegistration_Button"></span>
              </button>
            </div>

          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>